<form [formGroup]="form">
  <div class="p-fluid">
    <div class="flex align-items-center gap-4 p-mb-3">
      <p-radioButton name="jeCirilica" [value]="true" [formControl]="form.controls.jeCirilica"></p-radioButton>
      <label class="cursor-pointer p-ml-1" (click)="form.controls.jeCirilica.patchValue(true)">Ćirilica</label>

      <p-radioButton class="p-ml-3" name="jeCirilica" [value]="false" [formControl]="form.controls.jeCirilica"></p-radioButton>
      <label class="cursor-pointer p-ml-1" (click)="form.controls.jeCirilica.patchValue(false)">Latinica</label>
    </div>
    <kodit-text-input-field
      [formCtrl]="form.controls.arhiv!"
      formCtrlId="arhiv"
      formCtrlLabel="Arhiv"
    ></kodit-text-input-field>
    <kodit-text-input-field
      [formCtrl]="form.controls.postanskiBrojArhiva!"
      formCtrlId="postanskiBrojArhiva"
      formCtrlLabel="Poštanski broj arhiva"
    ></kodit-text-input-field>
    <kodit-text-input-field
      [formCtrl]="form.controls.adresaArhiva!"
      formCtrlId="adresaArhiva"
      formCtrlLabel="Adresa arhiva"
    ></kodit-text-input-field>
    <kodit-text-input-field
      [formCtrl]="form.controls.gradArhiva!"
      formCtrlId="gradArhiva"
      formCtrlLabel="Grad arhiva"
    ></kodit-text-input-field>
    <kodit-text-input-field
      [formCtrl]="form.controls.kontaktOsoba!"
      formCtrlId="kontaktOsoba"
      formCtrlLabel="Kontakt osoba"
    ></kodit-text-input-field>
    <kodit-text-input-field
      [formCtrl]="form.controls.mail!"
      formCtrlId="mail"
      formCtrlLabel="Email"
    ></kodit-text-input-field>
    <kodit-text-input-field
      [formCtrl]="form.controls.brojTelefona!"
      formCtrlId="brojTelefona"
      formCtrlLabel="Broj telefona"
    ></kodit-text-input-field>
  </div>
</form>
